import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ITimeLine } from '../../model/timeline.dto';

@Component({
  selector: 'hfc-shared-timeline',
  templateUrl: './shared-timeline.component.html',
  styleUrls: ['./shared-timeline.component.scss']
})
export class SharedTimelineComponent {
  @Input() timeLineContent: ITimeLine[] = [];
  @Output() newTimeLineStep = new EventEmitter<ITimeLine[]>();
  constructor() {}

  // To be used once state service is introduced.
  private updateStep(wizardStep: ITimeLine): ITimeLine[] {
    const oldIndex = this.timeLineContent.findIndex((step) => step.isActive);
    const newIndex = this.timeLineContent.indexOf(wizardStep);

    if (newIndex === -1 || oldIndex === -1) return null;

    return this.timeLineContent.map((step: ITimeLine, index: number): ITimeLine => {
      if (index === oldIndex) {
        return { ...step, isActive: false };
      }

      if (index === newIndex) {
        return { ...step, isActive: true };
      }

      return step;
    });
  }
}
